import { render, staticRenderFns } from "./RejectSalesNote.vue?vue&type=template&id=061a8f3c&"
import script from "./RejectSalesNote.vue?vue&type=script&lang=js&"
export * from "./RejectSalesNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports